import { Component, computed, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { IconComponent } from '../../../../../shared/components/icon/icon.component';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-readonly-photo',
  imports: [FormlyModule, ButtonComponent, IconComponent, TranslatePipe],
  templateUrl: './readonly-photo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './readonly-photo.component.css',
})
export class ReadonlyPhotoComponent extends FieldType<FieldTypeConfig> implements OnInit {
  photoDataUrls = signal<string[]>([]);

  filenamePrefix = computed(() => {
    const prefix = this.props['filenamePrefix'];
    return typeof prefix === 'string' && prefix.length > 0
      ? prefix
      : this.props['label'] || 'photo';
  });

  allowMultiple = computed(() => this.props['allowMultiplePhotos'] === true);

  ngOnInit(): void {
    const value = this.formControl.value;
    if (value) {
      if (Array.isArray(value)) {
        this.photoDataUrls.set(value);
      } else if (typeof value === 'string') {
        this.photoDataUrls.set([value]);
      }
    }
  }

  downloadPhoto(photoUrl: string, index: number): void {
    const link = window.document.createElement('a');
    link.href = photoUrl;
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
    const prefix = this.filenamePrefix();
    const photoNumber = this.allowMultiple() ? `-${index + 1}` : '';
    link.download = `${prefix}${photoNumber}-${timestamp}.jpg`;
    link.click();
  }
}
